import { FormTextField } from './FormTextField'
import { FormDropDown } from './FormDropDown'
import FormSwitch from './FormSwitch'
import { FormNumber } from './FormNumber'
import { FormSliderRange } from './FormSliderRange'

import { FormSelectMultiple } from './FormSelectMultiple'
import { FormPhoneNumber } from './FormPhoneNumber'
import { FormTime } from './FormTime'
import { COUNTRY_TYPE, CRUD_VIEW_TYPE } from '../../Types'

export const getFormType = (
  formConfigObj: any,
  index: number,
  formHook: any,
  viewType: CRUD_VIEW_TYPE = CRUD_VIEW_TYPE.CREATE,
  supportedCountries: COUNTRY_TYPE[] = []
) => {
  const type = formConfigObj.type

  const copy = { ...formConfigObj }

  const definedViewType = viewType ? viewType : CRUD_VIEW_TYPE.CREATE

  switch (type) {
    case 'TEXT':
      return <FormTextField key={index} viewType={definedViewType} data={copy} formHook={formHook}></FormTextField>

    case 'DROPDOWN':
      return <FormDropDown key={index} data={formConfigObj} formHook={formHook}></FormDropDown>

    case 'SWITCH':
      return <FormSwitch key={index} data={formConfigObj} formHook={formHook}></FormSwitch>

    case 'NUMBER':
      return <FormNumber key={index} data={formConfigObj} formHook={formHook}></FormNumber>

    case 'SLIDER_RANGE':
      return <FormSliderRange key={index} data={formConfigObj} formHook={formHook}></FormSliderRange>

    case 'SELECT_MULTIPLE':
      return <FormSelectMultiple key={index} data={formConfigObj} formHook={formHook}></FormSelectMultiple>

    case 'PHONE':
      return (
        <FormPhoneNumber
          key={index}
          data={formConfigObj}
          formHook={formHook}
          viewType={definedViewType}
          supportedCountries={supportedCountries}
        ></FormPhoneNumber>
      )

    case 'TIME':
      return <FormTime key={index} data={formConfigObj} formHook={formHook}></FormTime>

    default:
      return (
        <div key={Math.random() * 10} className="">
          WHAT
        </div>
      ) //<div key={index}>{type}</div>
  }
}
